import { Navigate } from "react-router-dom";
import useAPI from "@stores/api";

function parseJwt(token) {
  try {
    const base64Url = token.split(".")[1];
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split("")
        .map((c) => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2))
        .join("")
    );
    return JSON.parse(jsonPayload);
  } catch (e) {
    return null;
  }
}

function AdminRoute({ children }) {
  const token = useAPI((state) => state.token) || localStorage.getItem("token");

  if (!token) {
    return <Navigate to="/" />;
  }

  const payload = parseJwt(token);
  const isAdmin = payload && payload.sub === "admin";

  if (!isAdmin) {
    return <Navigate to="/" />;
  }

  return children;
}

export default AdminRoute;
